export default __webpack_public_path__ + "static/media/Cootie (2031).d54cc4b7.jpg";